<div class="confirmation">
  <div *ngIf="icon">
    <ng-container [ngSwitch]="iconWeight">
      <div *ngSwitchCase="IconWeight.LIGHT" class="confirmation__icon">
        <i class="fal fa-fw" ngClass="fa-{{ icon }}" [style.color]="iconColor"></i>
      </div>
      <div *ngSwitchCase="IconWeight.REGULAR" class="confirmation__icon">
        <i class="far fa-fw" ngClass="fa-{{ icon }}" [style.color]="iconColor"></i>
      </div>
      <div *ngSwitchCase="IconWeight.SOLID" class="confirmation__icon">
        <i class="fas fa-fw" ngClass="fa-{{ icon }}" [style.color]="iconColor"></i>
      </div>
      <div *ngSwitchCase="IconWeight.DUOTONE" class="confirmation__icon">
        <i class="fad fa-fw" ngClass="fa-{{ icon }}" [style.color]="iconColor"></i>
      </div>
      <div *ngSwitchCase="IconWeight.BRANDS" class="confirmation__icon">
        <i class="fab fa-fw" ngClass="fa-{{ icon }}" [style.color]="iconColor"></i>
      </div>
      <div *ngSwitchDefault class="confirmation__icon">
        <i class="fa fa-fw" ngClass="fa-{{ icon }}" [style.color]="iconColor"></i>
      </div>
    </ng-container>
  </div>
  <div class="confirmation__img" *ngIf="iconSrc">
    <vm-media [source]="iconSrc | mediaSrcStrapi: strapiUrl"></vm-media>
  </div>

  <div class="confirmation__title" *ngIf="title">
    <h1>{{ title }}</h1>
  </div>

  <div class="confirmation__title" *ngIf="subtitle">
    <h3>{{ subtitle }}</h3>
  </div>

  <div class="confirmation__info" *ngIf="info">
    <markdown ngPreserveWhitespaces>{{ info }}</markdown>
  </div>

  <ng-content select=".confirmation__before-actions"></ng-content>

  <div class="confirmation__actions" *ngIf="nextActions?.length">
    <ng-container *ngIf="nextActions?.length === 1 || nextActions[1]?.type === ButtonType.URL; else multiple_actions">
      <ng-container *ngFor="let nAction of nextActions">
        <div class="confirmation__actions--single" *ngIf="nAction.type !== ButtonType.URL">
          <vm-button
            *ngIf="nAction.type === 'button' || nAction.type === ButtonType.BUTTON"
            [type]="ButtonType.BUTTON"
            (click)="onNext($event, nAction.url, nAction.uid)"
            [level]="nAction?.buttonLevel"
            [styles]="[nAction?.buttonStyle]">
            {{ nAction.label }}
          </vm-button>

          <vm-button
            *ngIf="nAction.type === ButtonType.CHAT"
            [type]="ButtonType.CHAT"
            (click)="openChat($event)"
            [level]="nAction?.buttonLevel"
            [styles]="[nAction?.buttonStyle]"
            [vmLiveChatV3]="chatbotId">
            {{ nAction.label }}
          </vm-button>

          <vm-button
            *ngIf="nAction.type === 'a' || nAction.type === ButtonType.ROUTER_LINK"
            [routerLink]="nAction?.url"
            [level]="nAction?.buttonLevel"
            (click)="onNext($event, nAction.url, nAction.uid)">
            {{ nAction.label }}
          </vm-button>

          <vm-button
            *ngIf="nAction.type === ButtonType.LINK"
            [type]="ButtonType.LINK"
            [href]="nAction?.url"
            [level]="nAction?.buttonLevel">
            {{ nAction.label }}
          </vm-button>

          <vm-button
            *ngIf="nAction.type === ButtonType.MODAL"
            [type]="ButtonType.MODAL"
            (click)="openSecondaryModal($event)"
            [level]="nAction?.buttonLevel"
            [styles]="[nAction?.buttonStyle]">
            {{ nAction.label }}
          </vm-button>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #multiple_actions>
      <ng-container *ngFor="let nAction of nextActions; index as i">
        <div *ngIf="i < 2" class="confirmation__actions--cta">
          <vm-button
            *ngIf="nAction.type === 'button' || nAction.type === ButtonType.BUTTON"
            [type]="ButtonType.BUTTON"
            (buttonClick)="onNext($event, nAction.url, nAction.uid)"
            [vmLiveChatV3]="nAction?.chatId"
            [level]="nAction?.buttonLevel"
            [styles]="[nAction?.buttonStyle]">
            {{ nAction.label }}
          </vm-button>

          <vm-button
            *ngIf="nAction.type === ButtonType.COUNTDOWNCTA"
            [type]="ButtonType.COUNTDOWNCTA"
            (buttonClick)="onNext($event, nAction.url, nAction.uid)"
            [level]="nAction?.buttonLevel"
            [styles]="[nAction?.buttonStyle]">
            {{ nAction.label }}
          </vm-button>

          <vm-button
            *ngIf="nAction.type === ButtonType.CHAT"
            [type]="ButtonType.CHAT"
            (click)="openChat($event)"
            [level]="nAction?.buttonLevel"
            [styles]="[nAction?.buttonStyle]"
            [vmLiveChatV3]="chatbotId">
            {{ nAction.label }}
          </vm-button>

          <vm-button
            *ngIf="nAction.type === 'a' || nAction.type === ButtonType.ROUTER_LINK"
            [type]="nAction?.type || ButtonType.ROUTER_LINK"
            [level]="nAction?.buttonLevel"
            [styles]="[nAction?.buttonStyle]"
            (click)="onRoute($event, nAction.url)">
            {{ nAction.label }}
          </vm-button>

          <vm-button
            *ngIf="nAction.type === ButtonType.LINK"
            [type]="ButtonType.LINK"
            [href]="nAction?.url"
            [level]="nAction?.buttonLevel"
            [styles]="[nAction?.buttonStyle]">
            {{ nAction.label }}
          </vm-button>

          <vm-button
            *ngIf="nAction.type === ButtonType.MODAL"
            [type]="ButtonType.MODAL"
            (click)="openSecondaryModal($event)"
            [level]="nAction?.buttonLevel"
            [styles]="[nAction?.buttonStyle]">
            {{ nAction.label }}
          </vm-button>
        </div>
      </ng-container>
    </ng-template>
  </div>

  <ng-container *ngFor="let nAction of nextActions; index as i">
    <div class="confirmation__actions--tertiary" *ngIf="nAction.type === ButtonType.URL">
      <vm-link *ngIf="nAction?.url?.startsWith('http')" [type]="'standalone'" [href]="nAction?.url">
        {{ nAction.label }}
      </vm-link>
      <vm-link *ngIf="!nAction?.url?.startsWith('http')" [type]="'standalone'" [routerLink]="nAction?.url">
        {{ nAction.label }}
      </vm-link>
    </div>
  </ng-container>

  <div class="confirmation__actions--tertiary" *ngIf="nextActions?.length > 2">
    <vm-link (click)="onNextTertiary(nextActions[2], $event)" [type]="'standalone'" [href]="'#'">
      {{ nextActions[2]?.label }}
    </vm-link>
  </div>

  <div class="confirmation__extra-info" *ngIf="extraInfo">
    <markdown ngPreserveWhitespaces>
      {{ extraInfo }}
    </markdown>
  </div>

  <div class="confirmation__modal" *ngIf="tertiaryModalLabel && tertiaryModalCopy">
    <vm-link (click)="openTertiaryModal($event)" [type]="'standalone'" [href]="'#'">{{ tertiaryModalLabel }}</vm-link>
    <vm-modal
      *ngIf="isTertiaryModalOpen"
      [modalType]="modalType"
      [title]="tertiaryModalTitle ?? tertiaryModalLabel"
      [hideHeader]="false"
      (closeButtonClick)="isTertiaryModalOpen = false">
      <markdown ngPreserveWhitespaces>
        {{ tertiaryModalCopy }}
      </markdown>
    </vm-modal>
    <vm-modal
      *ngIf="isSecondaryModalOpen"
      [modalType]="secondaryModalType"
      [title]="secondaryModalLabel"
      [hideHeader]="false"
      (closeButtonClick)="isSecondaryModalOpen = false">
      <markdown ngPreserveWhitespaces>
        {{ secondaryModalCopy }}
      </markdown>
    </vm-modal>
  </div>

  <div class="tile-container" *ngIf="tiles?.length">
    <div class="vm-row">
      <vm-generic-tiles [tiles]="tiles" (selected)="onNext($event, $event?.id, $event?.uid)"> </vm-generic-tiles>
    </div>
  </div>

  <ng-content></ng-content>
</div>
